import AgenciesList from '@/components/routes/agencies/AgenciesList'
import AdminAgencySettings from '@/components/routes/agencies/adminAgencySettings/AdminAgencySettings'
import AgencyOverview from '@/components/routes/agency/AgencyOverview'
import AgencyEdit from '@/components/routes/agency/agencySettings/AgencyEdit'
import AgencyDisable from '@/components/routes/agencies/adminAgencySettings/AgencyDisable'

import fetchAgency from './utils/fetchAgency'

const agencyFetchProtectedRoutes = [
  {
    name: 'agencyOverview.admin',
    path: '/agencies/:agencyId',
    component: AgencyOverview,
    props: true
  },
  {
    name: 'agencySettings.admin',
    path: '/agencies/:agencyId/settings',
    component: AdminAgencySettings,
    redirect: {
      name: 'agencyEdit.admin'
    },
    children: [
      {
        name: 'agencyEdit.admin',
        path: 'agency-edit',
        component: AgencyEdit
      },
      {
        name: 'agencyDisable.admin',
        path: 'agency-disable',
        component: AgencyDisable
      }
    ]
  }
].map(route => {
  route.beforeEnter = fetchAgency
  return route
})

const agenciesRoutes = [
  {
    name: 'agencies',
    path: '/agencies',
    component: AgenciesList
  },
  ...agencyFetchProtectedRoutes
]

export default agenciesRoutes
